import {TweenMax, TimelineMax, Sine} from 'gsap';
const CustomEase = require('gsap/CustomEase');

Sine

const SizeMode = require('../utils/SizeMode');


const el = document.querySelector('.cover__next-ui__tips');
const ms = el.querySelector('.available-actions__item--mouse');
const msEl = ms.querySelector('.mouse-wheel');
const arrs = el.querySelector('.available-actions__item--arrows');
const arr1 = arrs.querySelector('.arr1');
const arr2 = arrs.querySelector('.arr2');
const arrLn1 = arrs.querySelector('.arr1-line');
const arrLn2 = arrs.querySelector('.arr2-line');
const tch = el.querySelector('.available-actions__item--touch');
const tchEl = tch.querySelector('.hand');
const tchCls = [...tch.querySelectorAll('.circle')];
const kb = el.querySelector('.available-actions__item--keyboard');
const kbOls = [...kb.querySelectorAll('.outline')];
let tl;
const tls = [];
let _onComplete;

const _killTL = function () {

    while (tls.length > 0) {
        tls.pop().kill();
    }

    if (!tl) return;
    tl.kill();
    tl = null;
};

const _completeTL = function () {
    if (typeof _onComplete !== 'function') return;
    _onComplete();
};

const _threeStepsTL = function (delay) {
    tl = new TimelineMax({
        delay: delay,
        onComplete: _completeTL
    });

    const d1 = 2.6;
    const d2 = 0.6;
    const d3 = 0.4;
    let t = 0;

    const ease1 = CustomEase.create('ease1', 'M0,0 C0.25,0 0.192,1 1,1');
    const ease2 = CustomEase.create('ease1', 'M0,0 C0.324,0 0.29,1 1,1');

    tl.to([ms, arrs], d2, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st');

    tl.from(arr1, d2, {
        x: -5,
        ease: ease2
    }, 'st');

    tl.from(arr2, d2, {
        x: 5,
        ease: ease2
    }, 'st');

    t += d2;

    _mouseTl(tl, t, d1);

    t += d1;

    tl.to(ms, d3, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + t);

    tl.to(arr1, d2 + d3 * 0.5, {
        x: 5,
        ease: ease2
    }, 'st+=' + t);

    tl.to(arr2, d2 + d3 * 0.5, {
        x: -5,
        ease: ease2
    }, 'st+=' + t);

    t += d3;

    tl.to(tch, d2, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st+=' + t);

    t += d2;

    _touchTl(tl, t, d1);

    t += d1;

    tl.to(tch, d3, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + t);

    tl.to(arr1, d2, {
        x: -5,
        ease: ease2
    }, 'st+=' + t);

    tl.to(arr2, d2, {
        x: 5,
        ease: ease2
    }, 'st+=' + t);

    tl.to(arrLn1, d2 * 0.75, {
        scaleX: 0,
        transformOrigin: '100% 50%',
        ease: ease1
    }, 'st+=' + t);

    tl.to(arrLn2, d2 * 0.75, {
        scaleX: 0,
        transformOrigin: '0% 50%',
        ease: ease1
    }, 'st+=' + t);

    t += d3;

    tl.to(kb, d2, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st+=' + t);

    t += d2;

    _kbTl(tl, t, d1);

    t += d1;

    tl.to(kb, d3, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + t);

    tl.to(arrs, d3, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + t);

    tl.to(arr1, d3, {
        x: -8,
        ease: Sine.easeInOut
    }, 'st+=' + t);

    tl.to(arr2, d3, {
        x: 8,
        ease: Sine.easeInOut
    }, 'st+=' + t);
};

const _touchStepTL = function (delay) {
    tl = new TimelineMax({
        delay: delay,
        onComplete: _completeTL
    });

    const d1 = 2.6;
    const d2 = 0.6;
    const d3 = 0.4;
    let t = 0;

    tl.to(arrs, d2, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st');

    tl.to(arr1, d2, {
        x: 5,
        ease: Sine.easeInOut
    }, 'st');

    tl.to(arr2, d2, {
        x: -5,
        ease: Sine.easeInOut
    }, 'st');

    tl.to(tch, d2, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st');

    t += d2;

    _touchTl(tl, 0.1, d1);

    t += d1;

    tl.to(tch, d3, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + t);

    tl.to(arrs, d3, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + t);

    tl.to(arr1, d3, {
        x: 8,
        ease: Sine.easeInOut
    }, 'st+=' + t);

    tl.to(arr2, d3, {
        x: -8,
        ease: Sine.easeInOut
    }, 'st+=' + t);
};

const _mouseTl = function (tl, start, duration) {
    let tl2;

    TweenMax.set(msEl, {
        y: 0,
        opacity: 0
    });

    tl.to(el, duration, {
        opacity: 1,
        onStart: () => {
            tl2 = new TimelineMax({
                repeat: -1
            });
            tl2.set(msEl, {
                y: 0,
                opacity: 0
            }, 'st');
            tl2.to(msEl, duration / 2, {
                y: 6
            }, 'st');
            tl2.to(msEl, duration / 4, {
                opacity: 1
            }, 'st');
            tl2.to(msEl, duration / 4, {
                opacity: 0
            }, 'st+=' + duration / 4);

            tls.push(tl2);
        },
        onComplete: () => {
            tl2.kill();
        }
    });

};

const _kbTl = function (tl, start, duration) {
    let tl2;

    TweenMax.set(kbOls, {
        opacity: 0
    });

    tl.to(el, duration, {
        opacity: 1,
        onStart: () => {
            tl2 = new TimelineMax();
            tl2.set(kbOls, {
                opacity: 0
            }, 'st');

            tl2.to(kbOls[1], duration * 0.8 / 8, {
                opacity: 1
            }, 'st');
            tl2.to(kbOls[1], duration * 0.8 / 8, {
                opacity: 0
            }, 'st+=' + duration * 0.8 / 8);
            tl2.to(kbOls[1], duration * 0.8 / 8, {
                opacity: 1
            }, 'st+=' + duration * 2 * 0.8 / 8);
            tl2.to(kbOls[1], duration * 0.8 * 1.4 / 8, {
                opacity: 0
            }, 'st+=' + duration * 3 * 0.8 / 8);

            tl2.to(kbOls[0], duration * 0.8 / 8, {
                opacity: 1
            }, 'st+=' + duration * 3.5 * 0.8 / 8);
            tl2.to(kbOls[0], duration / 8, {
                opacity: 0
            }, 'st+=' + duration * 4.5 * 0.8 / 8);
            tl2.to(kbOls[0], duration * 1.2 / 8, {
                opacity: 1
            }, 'st+=' + duration * (4.5 * 0.8 + 1) / 8);
            tl2.to(kbOls[0], duration * 1.4 * 1.2 / 8, {
                opacity: 0
            }, 'st+=' + duration * (4.5 * 0.8 + 1 + 1.2) / 8);


            tls.push(tl2);
        },
        onComplete: () => {
            tl2.kill();
        }
    });

};

const _touchTl = function (tl, start, duration) {
    let tl2;

    TweenMax.set(tchEl, {
        x: 8,
        opacity: 0
    });

    tl.to(el, duration, {
        opacity: 1,
        onStart: () => {
            tl2 = new TimelineMax({
                repeat: -1
            });
            tl2.set(tchEl, {
                x: 8,
                opacity: 0
            }, 'st');
            tl2.to(tchEl, duration / 2, {
                x: -8
            }, 'st');
            tl2.to(tchEl, duration / 4, {
                opacity: 1
            }, 'st');
            tl2.to(tchEl, duration / 4, {
                opacity: 0
            }, 'st+=' + duration / 4);


            const d = 0.25;
            tl2.set(tchCls[0], {
                scale: 0.2,
                transformOrigin: '50% 50%',
                opacity: 0
            }, 'st');
            tl2.to(tchCls[0], duration / 3.5, {
                scale: 1.5
            }, 'st+=' + d);
            tl2.to(tchCls[0], duration / 7, {
                opacity: 1
            }, 'st+=' + d);
            tl2.to(tchCls[0], duration / 7, {
                opacity: 0
            }, 'st+=' + (duration / 7 + d));


            tl2.set(tchCls[1], {
                scale: 0.2,
                transformOrigin: '50% 50%',
                opacity: 0
            }, 'st');
            tl2.to(tchCls[1], duration / 2.2, {
                scale: 1.2
            }, 'st');
            tl2.to(tchCls[1], duration / 5, {
                opacity: 1
            }, 'st');
            tl2.to(tchCls[1], duration / 5, {
                opacity: 0
            }, 'st+=' + duration / 5);

            tls.push(tl2);
        },
        onComplete: () => {
            tl2.kill();
        }
    });

};

module.exports.onComplete = f => {
    _onComplete = f;
};

module.exports.start = delay => {
    _killTL();

    switch (SizeMode(true)) {
        case 'horizontal':
            _threeStepsTL(delay);
            break;

        case 'vertical':
            _touchStepTL(delay);
            break;

        default:
            _completeTL();
            break;
    }




};

module.exports.destroy = () => {
    _killTL();
    _onComplete = undefined;
    if (el.parentNode) el.parentNode.removeChild(el);
};


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/components/TipsAnimation.js